import Card from "./Card";
import mapImage from "../assets/images/map-arkenom.png";

const Map = () => {
    return (
        <div>
            <Card className="w-full p-0 relative md:col-span-2 lg:col-span-1">
                <img src={mapImage} alt="Map" className="h-full w-full object-cover object-left-top" />
                <div className="absolute top-[58%] left-[48%] -translate-x-1/2 -translate-y-1/2 size-14 rounded-full after:conten-[''] after:absolute after:inset-0 after:outline after:outline-2 after:-outline-offset-2 after:rounded-full after:outline-gray-950/30">
                    <div className="absolute inset-0 rounded-full bg-gradient-to-r from-red-300 to-red-600 -z-20 animate-ping-large [animation-duration:2s]"></div>
                    <div className="absolute inset-0 rounded-full bg-gradient-to-r from-red-300/40 to-red-600/40 -z-10"></div>
                </div>
            </Card>
        </div>
    )
}
export default Map